import React, { useState, useEffect } from "react";
import "./styles.scss";

import { ReactComponent as SuccessIcon } from "../../assets/icons/Icons (1).svg";
import OrderDetail from "../../component/orderConfirm/orderDetail";
import ShippingBilling from "../../component/orderConfirm/shippingBilling";
import { useStateValue } from "../../store";
import { getPaymentStatus, getCartList } from "../../store/homeAction/action";
import { useLocation } from "react-router-dom";
import PaymentFailed from "../../component/checkout/paymentFailed";
import SkeletonLine from "../../common/Skeletion/line";

const OrderConfirmation = () => {
  const [data, setData] = useState(null);
  const [isValid, setIsvalid] = useState(null);
  const [{ checkoutPayment }, dispatch] = useStateValue();
  const location = useLocation();
  const { search } = location;
  const searchData = new URLSearchParams(search);
  const payment_intent = searchData.get("payment_intent");
  const intent_id = sessionStorage.getItem("payment_intent");

  useEffect(() => {
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    const mail = sessionStorage.getItem("mail_checkout");
    let payload = {
      email: mail,
      session_key: sessionStorage.getItem("session_key"),
      payment_intent_id: payment_intent ? payment_intent : intent_id,
      order_id: checkoutPayment?.order_id
        ? checkoutPayment?.order_id
        : sessionStorage.getItem("order_id"),
    };
    getPaymentStatus((res, error) => {
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
      if (res?.status) {
        setData(res?.data);
        setIsvalid(res?.status);
      } else if (!error?.status) {
        setData(error?.data);
        setIsvalid(error?.status);
      }

      getCartList((res, error) => {
        dispatch({
          type: "SET_CARTLIST_DATA",
          data: res,
        });
        sessionStorage.setItem(
          "iszipAuth",
          res?.data?.installation_content?.postal_code
        );
        dispatch({
          type: "SET_ZIP_CODE_POPUP",
          value: false,
          data: {
            installation: res?.data?.installation_content?.installation,
            fall_prevention: res?.data?.installation_content?.fall_prevention,
            zipCode: res?.data?.installation_content?.postal_code,
          },
        });
      }, payload);
    }, payload);
  }, []);

  return (
    <div className="order-confirmation-container">
      {isValid === false ? (
        <PaymentFailed data={data} />
      ) : isValid === true ? (
        <>
          {data ? (
            <>
              <div className="icon-section">
                <SuccessIcon />
                <p>
                  <span>{data?.thankyou_content?.thankyou}</span>
                  <span>{data?.thankyou_content?.order_confirm_text}</span>
                </p>
              </div>
              <OrderDetail data={data} />
              <ShippingBilling data={data} />
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        Array.from({ length: 3 }, (_, index) => (
          <SkeletonLine key={index} style={{ height: "20vh", margin: "2px" }} />
        ))
      )}
    </div>
  );
};

export default OrderConfirmation;
